module.exports = __webpack_public_path__ + "img/nicola.29881895.jpg";